import { useEffect } from 'react';
import ErrorService from '../../../services/ErrorService';

/**
 * Error tracking hook
 */
const useErrorTracking = () => {
  useEffect(() => {
    window.addEventListener(
      'error',
      (event: ErrorEvent) => {
        const { error } = event;
        if (
          error &&
          error.stack?.indexOf('invokeGuardedCallbackDev') >= 0 &&
          !error.alreadySeen
        ) {
          error.alreadySeen = true;
          event.preventDefault();
          return;
        }
        ErrorService.trackError(error);
      },
      { capture: true }
    );
  }, []);
};

export default useErrorTracking;
